// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import FileBackupIcon from "assets/icons/HeroIcons/FileBackupIcon";
// import Button from "view/components/Button";
// import apiLibrary from "services/api";
// import { useSelector } from "react-redux";
// import { RootState } from "store";
// import LoadingBar from "react-top-loading-bar";
// import { TailSpin } from "react-loader-spinner";
// import { useDispatch } from "react-redux";
// import { ThunkDispatch } from "redux-thunk";
// import { AnyAction } from "redux";
// import { reportVersionsAction } from "store/runReport";
// import { runReportData } from "store/runReport/initialState";
// import useCustomBranding from "hooks/useCustomBranding";

// export const LoaderReportCard = () => {
//   const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
//   const [progress, setProgress] = useState(0);
//   const [dataFetched, setDataFetched] = useState(false); // Track if data is fetched
//   const navigate = useNavigate();
//   const { reportsId } = useParams<any>();
//   const { primaryColor } = useCustomBranding();
//   const abortControllerRef = useRef<AbortController | null>(null); // Reference for the abort controller

//   // Fetch report data function with abort signal
//   const fetchReportData = useCallback(async () => {
//     if (abortControllerRef.current) {
//       abortControllerRef.current.abort(); // Abort any ongoing request before starting a new one
//     }

//     abortControllerRef.current = new AbortController(); // Create a new abort controller for the current request

//     try {
//       const { data } = await apiLibrary.Reports.getProcessedReportVersion(
//         reportsId,
//         abortControllerRef.current.signal
//       );

//       if (data?.id) {
//         setProgress(100); // Set progress to 100 once data is successfully fetched
//         setDataFetched(true); // Mark the data as fetched to prevent further retries
//         dispatch(reportVersionsAction(false));
//         // Ensure redirect happens only after progress reaches 100%
//         if (progress === 100) {
//           navigate(`/reports/${reportsId}/profile`);
//         }
//       }
//     } catch (error: any) {
//       if (error.name !== "AbortError") {
//         console.error("Error fetching report data", error);
//       }
//     }
//   }, [reportsId, dispatch, navigate, progress]); // Ensure progress is included in dependencies

//   // Simulate loader progress and fetch report data after completion
//   const simulateLoaderProgress = useCallback(async () => {
//     let progress = 10;
//     const maxProgress = 100;
//     const steps = 3;
//     const increment = (maxProgress - progress) / steps;

//     for (let step = 1; step <= steps; step++) {
//       if (dataFetched) return;

//       progress += increment;
//       setProgress(Math.min(maxProgress, progress));

//       // Wait for 3 seconds only on the first progress step (when it's 10%)
//       if (step === 1) {
//         await new Promise((resolve) => setTimeout(resolve, 300));
//       }
//     }

//     if (!dataFetched) {
//       await fetchReportData();
//     }
//   }, [dataFetched, fetchReportData]);

//   // const simulateLoaderProgress = useCallback(async () => {
//   //   let progress = 10;
//   //   const maxProgress = 100;
//   //   const steps = 3;
//   //   const increment = (maxProgress - progress) / steps;

//   //   for (let step = 1; step <= steps; step++) {
//   //     if (dataFetched) return; // Exit early if data has already been fetched

//   //     progress += increment;
//   //     setProgress(Math.min(maxProgress, progress));

//   //     // Simulate loading delay (no intervals or timeouts)
//   //     await new Promise((resolve: any) => resolve());
//   //   }

//   //   // Fetch report data after loader progress completes
//   //   if (!dataFetched) {
//   //     await fetchReportData(); // Fetch report data
//   //   }
//   // }, [dataFetched, fetchReportData]);

//   useEffect(() => {
//     if (!dataFetched) {
//       simulateLoaderProgress(); // Start the loader if data hasn't been fetched yet
//     }

//     return () => {
//       // Cleanup: Abort any pending requests when the component unmounts or when fetching completes
//       if (abortControllerRef.current) {
//         abortControllerRef.current.abort();
//       }
//     };
//   }, [dataFetched, reportsId, simulateLoaderProgress]);
//   return (
//     <div className="flex flex-col items-center justify-center w-full p-6 bg-bgWhite">
//       <div className="flex flex-col items-center justify-center w-full">
//         <FileBackupIcon fill={primaryColor}/>
//         <p className="pt-6 text-lg font-semibold text-center">
//           Please wait! Your report is being processed...
//         </p>
//         <p className="text-sm text-center textMidLight">
//           Processing... Approximate remaining time about 1 min...
//         </p>
//       </div>
//       {/* {progress > 0 && ( */}
//       <div className="my-4 spinner">
//         <TailSpin
//           height="40"
//           width="40"
//           color={primaryColor}
//           ariaLabel="tail-spin-loading"
//           radius="3"
//           wrapperStyle={{}}
//           wrapperClass="tailspin-loader"
//           visible={true}
//           strokeWidth={3}
//         />
//       </div>
//       <div className="flex items-center gap-2 loadingbar">
//         <div className="relative w-[30vw] h-1 bg-secondary_25">
//           <LoadingBar
//             color={primaryColor}
//             progress={progress}
//             height={3}
//             containerClassName="!absolute"
//             shadow={false}
//             waitingTime={1000000}
//           />
//         </div>
//         <p className="text-sm font-Overpass text-textMid dark:text-caption ">
//           {progress}%
//         </p>
//       </div>
//       <div className="flex justify-center mt-6 mb-4">
//         <Button
//           type="button"
//           text="Go to Reports Directory"
//           filledColor="primary"
//           outlinedColor="primary"
//           textColor="textWhite"
//           className="px-5 py-2 "
//           width="35"
//           height="13"
//           fontStyle="font-semibold"
//           variant="outlined"
//           onClick={() => navigate(`/reports/list`)}
//         />
//       </div>
//       <div>
//         <p className="text-primary text-lg">
//           Your report will keep processing in the background, you will recieve a
//           notification when the report is done
//         </p>
//       </div>
//     </div>
//   );
// };
// export default LoaderReportCard;

import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FileBackupIcon from "assets/icons/HeroIcons/FileBackupIcon";
import Button from "view/components/Button";
import apiLibrary from "services/api";
import { useDispatch } from "react-redux";
import LoadingBar from "react-top-loading-bar";
import { TailSpin } from "react-loader-spinner";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { reportVersionsAction } from "store/runReport";
import useCustomBranding from "hooks/useCustomBranding";

export const LoaderReportCard = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const [progress, setProgress] = useState(0);
  const [dataFetched, setDataFetched] = useState(false); // Track if data is fetched
  const navigate = useNavigate();
  const { reportsId } = useParams<any>();
  const { primaryColor } = useCustomBranding();
  const abortControllerRef = useRef<AbortController | null>(null); // Reference for the abort controller
  const retryCount = useRef(0); // To track retry attempts
  const redirectTimeoutRef = useRef<NodeJS.Timeout | null>(null); // Ref to store the timeout ID
  const isMountedRef = useRef(true); // To prevent actions after unmount
  const dataFetchedRef = useRef(false); // Ref to track fetched state for polling without stale closures
  const lastProgressRef = useRef(0); // Track last progress to detect stalls
  const finalIncrementIntervalRef = useRef<NodeJS.Timeout | null>(null); // Ref for final increment interval
  const finalIncrementingRef = useRef(false); // Track if final increment phase is active

  // Function to start final increment from 95 to 100 every second
  const startFinalIncrement = useCallback(() => {
    if (finalIncrementingRef.current || !isMountedRef.current) return;
    finalIncrementingRef.current = true;
    let incrementSteps = 0; // 0 to 5 for 95 to 100

    finalIncrementIntervalRef.current = setInterval(() => {
      if (!isMountedRef.current) {
        clearInterval(finalIncrementIntervalRef.current!);
        return;
      }

      incrementSteps++;
      const newProgress = 95 + incrementSteps;

      if (newProgress <= 100) {
        setProgress(newProgress);
      }

      if (newProgress >= 100) {
        clearInterval(finalIncrementIntervalRef.current!);
        setProgress(100);
        setDataFetched(true);
        dataFetchedRef.current = true;

        // Start the 1-second timer before redirecting
        if (redirectTimeoutRef.current) {
          clearTimeout(redirectTimeoutRef.current);
        }

        redirectTimeoutRef.current = setTimeout(() => {
          if (isMountedRef.current) {
            navigate(`/reports/${reportsId}/profile`);
            dispatch(reportVersionsAction(false));
          }
        }, 1000);
      }
    }, 1000);
  }, [reportsId, dispatch, navigate]);

  // Fetch report data function with abort signal
  const fetchReportData = useCallback(async () => {
    if (!isMountedRef.current) return; // Prevent fetch if unmounted

    if (abortControllerRef.current) {
      abortControllerRef.current.abort(); // Abort any ongoing request before starting a new one
    }

    abortControllerRef.current = new AbortController(); // Create a new abort controller for the current request

    try {
      const { data } = await apiLibrary.Reports.getProcessedReportVersion(
        reportsId,
        abortControllerRef.current.signal
      );

      // Handle response and progress
      if (data?.id) {
        if (!isMountedRef.current) return; // Double-check before updating state
        setProgress(95); // Set progress to 95 once data is successfully fetched
        setDataFetched(true); // Mark the data as fetched to prevent further retries/polling
        dataFetchedRef.current = true;

        // Start final increment to 100
        startFinalIncrement();
      } else if (data?.percentage) {
        if (!isMountedRef.current) return; // Double-check before updating state
        // Update the progress as percentage is received (up to 95 max from API)
        const apiProgress = Math.min(95, data.percentage);
        setProgress(apiProgress);
        lastProgressRef.current = apiProgress;

        // If reached 95 from API, start final increment simulation
        if (apiProgress >= 95 && !finalIncrementingRef.current) {
          startFinalIncrement();
        }

        // If not done, schedule next poll after 3 seconds (but stop if final incrementing)
        if (
          apiProgress < 95 &&
          !dataFetchedRef.current &&
          !finalIncrementingRef.current
        ) {
          setTimeout(() => {
            if (isMountedRef.current) {
              fetchReportData();
            }
          }, 3000);
        }
      }
    } catch (error: any) {
      if (error.name !== "AbortError" && isMountedRef.current) {
        console.error("Error fetching report data", error);

        // Retry logic if the fetch failed
        if (retryCount.current < 3) {
          retryCount.current++;
          setTimeout(() => {
            if (isMountedRef.current) {
              fetchReportData();
            }
          }, 3000); // Retry after 3 seconds
        } else {
          console.error("Max retries reached.");
          // Optionally, set an error state here to show user feedback
          // Fallback: Force start final increment if stalled at high progress
          if (
            lastProgressRef.current >= 90 &&
            !dataFetchedRef.current &&
            !finalIncrementingRef.current
          ) {
            setProgress(95);
            startFinalIncrement();
          }
        }
      }
    }
  }, [reportsId, dispatch, navigate, startFinalIncrement]); // Added startFinalIncrement to deps

  // Use effect to call the fetchReportData function
  useEffect(() => {
    fetchReportData(); // Initial fetch on mount

    return () => {
      isMountedRef.current = false; // Mark as unmounted
      // Cleanup: Abort any pending requests and clear the timeout when the component unmounts
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      if (redirectTimeoutRef.current) {
        clearTimeout(redirectTimeoutRef.current); // Clear the timeout when unmounting
      }
      if (finalIncrementIntervalRef.current) {
        clearInterval(finalIncrementIntervalRef.current);
      }
    };
  }, [fetchReportData]); // Stable deps prevent extra cleanups on dataFetched change

  return (
    <div className="flex flex-col items-center justify-center w-full p-6 bg-bgWhite">
      <div className="flex flex-col items-center justify-center w-full">
        <FileBackupIcon fill={primaryColor} />
        <p className="pt-6 text-lg font-semibold text-center">
          Please wait! Your report is being processed...
        </p>
        <p className="text-sm text-center textMidLight">
          Processing... Approximate remaining time about 1 min...
        </p>
      </div>

      <div className="my-4 spinner">
        <TailSpin
          height="40"
          width="40"
          color={primaryColor}
          ariaLabel="tail-spin-loading"
          radius="3"
          wrapperStyle={{}}
          wrapperClass="tailspin-loader"
          visible={true}
          strokeWidth={3}
        />
      </div>

      <div className="flex items-center gap-2 loadingbar">
        <div className="relative w-[30vw] h-1 bg-secondary_25">
          <LoadingBar
            color={primaryColor}
            progress={progress}
            height={3}
            containerClassName="!absolute"
            shadow={false}
            waitingTime={1000000}
          />
        </div>
        <p className="text-sm font-Overpass text-textMid dark:text-caption ">
          {progress}%
        </p>
      </div>

      <div className="flex justify-center mt-6 mb-4">
        <Button
          type="button"
          text="Go to Reports Directory"
          filledColor="primary"
          outlinedColor="primary"
          textColor="textWhite"
          className="px-5 py-2 "
          width="35"
          height="13"
          fontStyle="font-semibold"
          variant="outlined"
          onClick={() => navigate(`/reports/list`)}
        />
      </div>

      <div>
        <p className="text-primary text-lg">
          Your report will keep processing in the background, you will recieve a
          notification when the report is done
        </p>
      </div>
    </div>
  );
};

export default LoaderReportCard;
